import React, { Fragment } from "react";
import { Layout } from "../components/Layout";
import { isLoggedIn, selectUser } from "../store/reducers";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getOrdinal } from "../getOrdinal";
import { Typography } from "@material-ui/core";
import styled from "styled-components";

const Root = styled.div`
    text-align: center;
`;

let Home = ({ isLoggedIn, user }) => {
    return (
        <Layout>
            <Root>
                <Typography paragraph={true} variant="h1">
                    Welcome
                </Typography>
                {isLoggedIn && (
                    <Fragment>
                        <Typography paragraph={true} variant="h6">
                            You're {user.position && getOrdinal(user.position)} in
                            the waiting list
                        </Typography>
                        <Typography paragraph={true}>
                            Thanks for signing up. Sorry, we're still working on
                            things.
                        </Typography>
                        <Typography paragraph={true}>
                            In the meantime, why don't you add your{" "}
                            <Link to="/interests">preferences</Link> so we know what
                            kind of news to show you when the site is ready.
                        </Typography>
                        <Typography paragraph={true}>
                            If you're feeling really brave, take a look at a very
                            early protype of your <Link to="/feed">news feed</Link>.
                        </Typography>
                    </Fragment>
                )}
                {!isLoggedIn && (
                    <Fragment>
                        <Typography paragraph={true}>
                            Thanks for your interest in Onews. Sorry, we're still
                            working on things.
                        </Typography>
                        <Typography paragraph={true}>
                            But you can <Link to={"/register"}>register</Link> now
                            to join the queue and we'll let you know when you can
                            start reading.
                        </Typography>
                    </Fragment>
                )}
            </Root>
        </Layout>
    );
};

const mapState = state => ({
    isLoggedIn: isLoggedIn(state),
    user: selectUser(state)
});

Home = connect(mapState)(Home);

export { Home };



// WEBPACK FOOTER //
// ./src/pages/Home.js